import { useEffect } from 'react';

/**
 * @typedef AnimatedRef
 * @type {object}
 * @property {import('react').MutableRefObject<HTMLImageElement>} elementRef - Element Reference defaults
 * @property {number} speed - Animation speed - defaults to 2
 * @property {'rotation' | 'bounce'} animationType - Animation Type - defaults to 'rotation'
 */

/**
 * Animate an array of elements given its references
 * @param {[AnimatedRef]} elements
 * @returns null
 */
export const useScrollAnimation = (elements = []) => {
  useEffect(() => {
    const handleScroll = () => {
      if (elements.length) {
        elements.forEach(
          ({ elementRef, speed = 2, animationType = 'rotation' }) => {
            if (elementRef.current) {
              if (animationType === 'rotation') {
                // eslint-disable-next-line no-param-reassign
                elementRef.current.style.transition = 'all ease-out 0.5s';
                // eslint-disable-next-line no-param-reassign
                elementRef.current.style.transform = `rotate(${
                  window.pageYOffset / speed
                }deg)`;
              } else {
                // eslint-disable-next-line no-param-reassign
                elementRef.current.style.transition = 'all ease-out 0.5s';
                // eslint-disable-next-line no-param-reassign
                elementRef.current.style.transform = `translateX(${
                  window.pageYOffset / speed
                }px)`;
              }
            }
          }
        );
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }
    return () => window.removeEventListener('scroll', handleScroll);
  }, [elements]);
  return null;
};
